import api from 'data/api';

export const removePreset = api('DELETE /api/user/presets/:id');
